var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pui-datatable',{attrs:{"modelName":_vm.model,"actions":_vm.actions}}),(!_vm.isLdapActive)?_c('userappresetpassworddialog',{attrs:{"modelName":_vm.model}}):_vm._e(),_c('userAppModalsdialog',{attrs:{"modelName":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }